<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { authHeader } from "../../../helpers/auth-header";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import ListingTable from "@/components/listings/listing-table";

import InputGroup from "@/components/forms/input-group";
import SelectGroup from "@/components/forms/select-group";

export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        ListingTable,
        InputGroup,
        SelectGroup
    },
    data() {
        return {
            title: "Bookings",
            items: [
                {
                    text: "Bookings"
                },
            ],
            filter: {
                keyword: '',
                branch: '',
                product: '',
                from_date: '',
                to_date: '',
                status: '',
                staff: '',
            },
            statusOptions: [
                { name: 'Ordered', value: 'ordered' },
                { name: 'Booked', value: 'booked' },
                { name: 'Completed', value: 'completed' },
                { name: 'Cancelled', value: 'cancelled' },
                { name: 'Expired', value: 'expired' },
            ],
            branchOptions: [],
            productOptions: [],
            fields: [
                { key: "action" },
                { key: 'id', sortable: true, label: 'ID' },
                { key: 'order_id', sortable: true, label: 'Booking ID' },
                { key: 'shopify_id', sortable: true, label: 'Shopify Order ID' },
                { key: "customer_name", sortable: false, label: 'Customer Name' },
                { key: "customer_email", sortable: false, label: 'Customer Email' },
                { key: "booking_date", sortable: false, label: 'Booking Date' },
                { key: "status", sortable: false, label: "Status" },
                { key: "branch_id", sortable: true, label: "Branch" },
                { key: "product_name", sortable: true, label: "Treatment" },
                { key: "staff_name", sortable: true, label: "Therapist" },
            ],
            userType: '',
            staffID: ''
        };
    },
    computed: {
        //
    },
    watch: {
        //
    },
    async mounted() {
        const userData = localStorage.getItem('user');
        const userObject = JSON.parse(userData);
        const userType = userObject.user_type;
        this.userType = userType;

        this.retrieveBranches().then((branches) => {
            this.branchOptions = branches.map((branch) => ({
                name: branch.name,
                value: branch.id,
            }));
        });

        this.retrieveProducts().then((products) => {
            const productArray = Object.values(products);
            this.productOptions = productArray.map((product) => ({
                name: product.description.name,
                value: product.shopify_product_id,
            }));
        });
    },
    methods: {
        capitalizeFirstLetter(value) {
            if (typeof value !== 'string') {
                return value;
            }
            
            return value.charAt(0).toUpperCase() + value.slice(1);
        },

        async retrieveBranches() {
            this.loading = true;
            let branches = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/branch`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    branches = result['data'].branches;
                }
            } catch (e) {
                console.error(e);
            }

            this.loading = false;
            return branches;
        },

        async retrieveProducts() {
            this.loading = true;
            let products = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/all-product`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    products = result['data'].products;
                }
            } catch (e) {
                console.error(e);
            }

            this.loading = false;
            return products;
        },

        deleteRecord(id) {
            const deleteCallback = async () => {
                await axios.delete(`${process.env.VUE_APP_APIURL}/order/${id}`, {
                    headers: authHeader(),
                });
                this.filterTable();
                this.$refs.confirmationModal.closeModal();
                this.$refs.messageModal.showModal('The record has been deleted');
            }
            this.$refs.confirmationModal.showModal(`Confirm delete booking (ID: ${id})?`, deleteCallback);
        },

        setAdminView(filter) {
            this.filter = Object.assign(this.filter, filter);
        },

        filterTable() {
            const filter = this.filter;
            this.$refs.listingTable.filterTable(filter);
        },

        resetTable() {
            this.filter = {
                keyword: '',
                branch: '',
                product: '',
                from_date: '',
                to_date: '',
                status: '',
                staff: '',
            };

            const filter = this.filter;
            this.$refs.listingTable.filterTable(filter);
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body pt-0">
                        <div class="row mt-2 ml-0" v-if="this.userType == 'admin'">
                            <router-link class="btn btn-success mb-2" :to="{name: 'Booking Form', params: {id: 'add'}}"><i class="mdi mdi-plus mr-2"></i> Add Booking</router-link>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-4 mt-2">
                                <InputGroup id="search" type="text" displayName="Search" v-model="filter.keyword" :onEnter="filterTable" :placeholder="'Search by customer name or email or order ID'" />
                            </div>
                            <div class="col-sm-12 col-md-4 mt-2" v-if="this.userType == 'admin'">
                                <SelectGroup id="branch" displayName="Branch" v-model="filter.branch" :options="branchOptions" />
                            </div>
                            <div class="col-sm-12 col-md-4 mt-2">
                                <SelectGroup id="treatment" displayName="Treatment" v-model="filter.product" :options="productOptions" />
                            </div>
                            <div class="col-sm-12 col-md-4 mt-2">
                                <InputGroup id="from_date" type="date" v-model="filter.from_date" displayName="From Date" />
                            </div>
                            <div class="col-sm-12 col-md-4 mt-2">
                                <InputGroup id="to_date" type="date" v-model="filter.to_date" displayName="To Date"/>
                            </div>
                            <div class="col-sm-12 col-md-4 mt-2">
                                <SelectGroup id="status" displayName="Status" v-model="filter.status" :options="statusOptions" />
                            </div>
                            <div class="col-12">
                                <a href="javascript:void(0);" class="btn btn-success mt-2" @click="filterTable">
                                    Filter
                                </a>
                                <a href="javascript:void(0);" class="btn btn-danger ml-3 mt-2" @click="resetTable">
                                    Reset
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="pl-4 pr-4" v-if="this.userType == 'admin'">
                        <ListingTable ref="listingTable" :fields="fields" :setAdminView="setAdminView" path="order" listName="orders">
                            <template v-slot:cell(status)="row">
                                <div class="badge font-size-12" :class="{
                                    'badge-soft-danger': row.value === 'cancelled' || row.value === 'expired',
                                    'badge-soft-warning': row.value === 'pending' || row.value === 'ordered',
                                    'badge-soft-success': row.value === 'booked' || row.value === 'completed',
                                }">{{ capitalizeFirstLetter(row.value) }}</div>
                            </template>
                            <template v-slot:cell(action)="{ item }">
                                <router-link class="mr-3 text-primary" :to="{name: 'Booking Form', params: {id: item.id}}"><i class="mdi mdi-pencil font-size-18" v-b-tooltip.hover title="Edit"></i></router-link>
                                <!-- <a href="javascript:void(0);" class="text-danger" v-b-tooltip.hover title="Delete"
                                    @click="deleteRecord(item.id)">
                                    <i class="mdi mdi-trash-can font-size-18"></i>
                                </a> -->
                            </template>
                        </ListingTable>
                    </div>

                    <div class="pl-4 pr-4" v-else>
                        <ListingTable ref="listingTable" :fields="fields" :setAdminView="setAdminView" path="staff-order" listName="orders" from="staff_booking">
                            <template v-slot:cell(status)="row">
                                <div class="badge font-size-12" :class="{
                                    'badge-soft-danger': row.value === 'cancelled' || row.value === 'expired',
                                    'badge-soft-warning': row.value === 'pending' || row.value === 'ordered',
                                    'badge-soft-success': row.value === 'booked' || row.value === 'completed',
                                }">{{ capitalizeFirstLetter(row.value) }}</div>
                            </template>
                            <template v-slot:cell(action)="{ item }">
                                <router-link class="mr-3 text-primary" :to="{name: 'Booking Staff Form', params: {id: item.id}}"><i class="mdi mdi-eye-outline font-size-18" v-b-tooltip.hover title="View"></i></router-link>
                            </template>
                        </ListingTable>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>